import React from "react";
import Breadcrumb from "../../components/Breadcrumb";

const highlights = [
  { icon: "flaticon-hospital-1", value: "7", label: "Operation Theaters" },
  { icon: "flaticon-stethoscope", value: "24/7", label: "Emergency Services" },
  { icon: "flaticon-first-aid", value: "100+", label: "Specialist Doctors" },
  { icon: "flaticon-heart-1", value: "2009", label: "Year Established" },
];

const ChairmanMessageMain = ({ asSection = false }) => {
  const Tag = asSection ? "div" : "main";
  return (
    <Tag>
      {!asSection && <Breadcrumb title="Chairman's Message" subTitle="Chairman's Message" />}

      {/* ── Main Chairman Section ──────────────────────────── */}
      <section className="pt-120 pb-100">
        <div className="container">
          <div className="row g-5 align-items-start">
            {/* ── Portrait Column ── */}
            <div className="col-xl-4 col-lg-5 wow animate__fadeInLeft" data-wow-duration=".9s" data-wow-delay=".3s">
              {/* Outer wrapper with extra bottom padding for the nameplate */}
              <div style={{ position: "relative", paddingBottom: "36px" }}>
                {/* Decorative offset background block */}
                <div
                  style={{
                    position: "absolute",
                    top: "24px",
                    left: "-24px",
                    width: "88%",
                    height: "92%",
                    background: "linear-gradient(135deg, #1b74bb 0%, #0d4f8a 100%)",
                    borderRadius: "16px",
                    zIndex: 0,
                  }}
                />

                {/* Decorative corner accent */}
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    right: "10px",
                    width: "60px",
                    height: "60px",
                    borderTop: "4px solid #1b74bb",
                    borderRight: "4px solid #1b74bb",
                    borderRadius: "0 8px 0 0",
                    zIndex: 3,
                    opacity: 0.4,
                  }}
                />

                {/* Photo frame */}
                <div
                  style={{
                    position: "relative",
                    zIndex: 1,
                    borderRadius: "16px",
                    overflow: "hidden",
                    boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
                  }}
                >
                  <img
                    src="/images/chairman.png"
                    alt="Chairman – Maroof International Hospital"
                    style={{ width: "100%", display: "block", objectFit: "cover", maxHeight: "500px" }}
                  />
                  {/* Subtle blue tint overlay on bottom */}
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: 0,
                      height: "30%",
                      background: "linear-gradient(to top, rgba(13,79,138,0.55) 0%, transparent 100%)",
                    }}
                  />
                </div>

                {/* Nameplate card */}
                <div
                  style={{
                    position: "absolute",
                    bottom: "0",
                    left: "24px",
                    right: "8px",
                    background: "#fff",
                    borderRadius: "12px",
                    padding: "16px 22px",
                    boxShadow: "0 10px 40px rgba(0,0,0,0.14)",
                    zIndex: 2,
                    borderLeft: "5px solid #1b74bb",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "2px",
                      textTransform: "uppercase",
                      color: "#1b74bb",
                      marginBottom: "4px",
                    }}
                  >
                    Chairman
                  </p>
                  <h5
                    style={{
                      margin: 0,
                      fontSize: "17px",
                      fontWeight: 800,
                      color: "#0e1c3d",
                      lineHeight: 1.25,
                    }}
                  >
                    Maroof International Hospital
                  </h5>
                </div>
              </div>
            </div>

            {/* ── Message Column ── */}
            <div
              className="col-xl-8 col-lg-7 wow animate__fadeInRight"
              data-wow-duration=".9s"
              data-wow-delay=".4s"
              style={{ paddingLeft: "clamp(16px, 3vw, 48px)" }}
            >
              {/* Section subtitle tag */}
              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "14px" }}>
                <span
                  style={{
                    display: "inline-block",
                    width: "36px",
                    height: "3px",
                    background: "#1b74bb",
                    borderRadius: "2px",
                  }}
                />
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 700,
                    letterSpacing: "2.5px",
                    textTransform: "uppercase",
                    color: "#1b74bb",
                  }}
                >
                  Leadership &amp; Vision
                </span>
              </div>

              {/* Heading */}
              <h2
                style={{
                  fontSize: "clamp(26px, 3.2vw, 40px)",
                  fontWeight: 800,
                  color: "#0e1c3d",
                  lineHeight: 1.2,
                  marginBottom: "28px",
                }}
              >
                A Message from <span style={{ color: "#1b74bb" }}>Our Chairman</span>
              </h2>

              {/* Decorative quote bar */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                  marginBottom: "28px",
                  padding: "20px 24px",
                  background: "linear-gradient(135deg, #e8f2fb 0%, #f0f7ff 100%)",
                  borderRadius: "12px",
                  borderLeft: "4px solid #1b74bb",
                }}
              >
                <i
                  className="fas fa-quote-left"
                  style={{ fontSize: "28px", color: "#1b74bb", opacity: 0.7, flexShrink: 0, marginTop: "2px" }}
                />
                <p
                  style={{
                    margin: 0,
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#0e1c3d",
                    lineHeight: 1.7,
                    fontStyle: "italic",
                  }}
                >
                  Built on a promise to deliver the best of health to every citizen — Maroof International Hospital stands as a testament to
                  what compassionate, world-class healthcare looks like.
                </p>
              </div>

              {/* Message paragraphs */}
              <p style={{ fontSize: "15.5px", lineHeight: 1.9, color: "#555", marginBottom: "20px" }}>
                Maroof International Hospital is a hospital with a concept built on providing the{" "}
                <strong>best of health to every citizen</strong>. Started in 2009, it is an effort to take the healthcare to the next level. The
                comfortable atmosphere that it offers causes a person to feel the peace. Its vibes and decor rival the best anywhere and its
                infrastructure including <strong>diagnostics (laboratory &amp; imaging)</strong> is second to none.
              </p>

              <p style={{ fontSize: "15.5px", lineHeight: 1.9, color: "#555", marginBottom: "20px" }}>
                Based on <strong>seven operation theaters</strong> that are equipped with the latest technology, its surgical field is able to
                cater for most types of surgical treatments. It also offers the latest in <strong>haemo dialysis</strong> on an outpatient
                basis. Its ER/Emergency gives an impression of a friendly and welcoming place for patients and relatives both. The staff in all
                out-patient and in-patient departments is friendly, competent and caring.
              </p>

              <p style={{ fontSize: "15.5px", lineHeight: 1.9, color: "#555", marginBottom: "32px" }}>
                The hospital has a special <strong>Patient Coordination Department</strong> that coordinates with doctors, nurses, and
                interpreters who serve the patients. It ensures the comfortable and smooth provision of services to each and every patient
                entering its doors.
              </p>

              {/* Signature block */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  paddingTop: "24px",
                  borderTop: "1px solid #e2ecf7",
                }}
              >
                {/* Signature avatar initials */}
                <div
                  style={{
                    width: "54px",
                    height: "54px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #1b74bb 0%, #0d4f8a 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    boxShadow: "0 6px 20px rgba(27,116,187,0.35)",
                  }}
                >
                  <i className="flaticon-hospital" style={{ color: "#fff", fontSize: "22px" }} />
                </div>
                <div>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: 800,
                      color: "#0e1c3d",
                      lineHeight: 1.3,
                    }}
                  >
                    Chairman
                  </p>
                  <p style={{ margin: 0, fontSize: "13.5px", color: "#1b74bb", fontWeight: 500 }}>Maroof International Hospital, Islamabad</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Hospital Highlights Strip ──────────────────────── */}
      <section
        style={{
          background: "linear-gradient(135deg, #0e1c3d 0%, #1b40a0 50%, #1b74bb 100%)",
          padding: "60px 0",
        }}
      >
        <div className="container">
          <div className="row justify-content-center mb-40">
            <div className="col-12 text-center">
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: 700,
                  letterSpacing: "3px",
                  textTransform: "uppercase",
                  color: "rgba(255,255,255,0.65)",
                  marginBottom: "8px",
                }}
              >
                By the Numbers
              </p>
              <h3 style={{ fontSize: "clamp(22px, 2.8vw, 32px)", fontWeight: 800, color: "#fff", margin: 0 }}>Excellence in Every Metric</h3>
            </div>
          </div>
          <div className="row g-4 justify-content-center">
            {highlights.map((h, i) => (
              <div key={i} className="col-xl-3 col-lg-3 col-sm-6 col-6">
                <div
                  style={{
                    textAlign: "center",
                    padding: "32px 20px",
                    background: "rgba(255,255,255,0.08)",
                    borderRadius: "16px",
                    border: "1px solid rgba(255,255,255,0.12)",
                    backdropFilter: "blur(8px)",
                    transition: "transform .25s, background .25s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-6px)";
                    e.currentTarget.style.background = "rgba(255,255,255,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.background = "rgba(255,255,255,0.08)";
                  }}
                >
                  <div
                    style={{
                      width: "56px",
                      height: "56px",
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.15)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                    }}
                  >
                    <i className={h.icon} style={{ fontSize: "24px", color: "#fff" }} />
                  </div>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "clamp(28px, 3.5vw, 40px)",
                      fontWeight: 800,
                      color: "#fff",
                      lineHeight: 1,
                      marginBottom: "6px",
                    }}
                  >
                    {h.value}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "rgba(255,255,255,0.7)",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {h.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Commitment Banner ─────────────────────────────── */}
      <section style={{ padding: "76px 0", background: "#f7f9fc" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-9 col-lg-10 text-center wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".3s">
              <div
                style={{
                  background: "#fff",
                  borderRadius: "20px",
                  padding: "52px 48px",
                  boxShadow: "0 12px 50px rgba(0,0,0,0.08)",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {/* Background accent shapes */}
                <div
                  style={{
                    position: "absolute",
                    top: "-30px",
                    right: "-30px",
                    width: "120px",
                    height: "120px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #1b74bb 0%, #0d4f8a 100%)",
                    opacity: 0.07,
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    bottom: "-40px",
                    left: "-40px",
                    width: "160px",
                    height: "160px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #1b74bb 0%, #0d4f8a 100%)",
                    opacity: 0.05,
                  }}
                />

                <div style={{ position: "relative", zIndex: 1 }}>
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #1b74bb 0%, #0d4f8a 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 20px",
                      boxShadow: "0 8px 24px rgba(27,116,187,0.3)",
                    }}
                  >
                    <i className="flaticon-heart-1" style={{ color: "#fff", fontSize: "24px" }} />
                  </div>

                  <p
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "3px",
                      textTransform: "uppercase",
                      color: "#1b74bb",
                      marginBottom: "12px",
                    }}
                  >
                    Our Commitment
                  </p>

                  <h3
                    style={{
                      fontSize: "clamp(20px, 2.5vw, 28px)",
                      fontWeight: 800,
                      color: "#0e1c3d",
                      lineHeight: 1.4,
                      marginBottom: "16px",
                    }}
                  >
                    Delivering Compassionate Care, <span style={{ color: "#1b74bb" }}>Every Single Day</span>
                  </h3>

                  <p
                    style={{
                      fontSize: "15px",
                      lineHeight: 1.85,
                      color: "#666",
                      maxWidth: "620px",
                      margin: "0 auto",
                    }}
                  >
                    From our Emergency Room to our specialized wards, every corner of Maroof International Hospital is designed around one
                    simple principle: the patient comes first. Our dedicated staff work tirelessly to uphold this promise.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Tag>
  );
};

export default ChairmanMessageMain;
